const isProdEnv = process.env.NODE_ENV === 'production'

const sendDDLog = queryParams => {
  if (isProdEnv && navigator.sendBeacon) {
    const route = window.dataLayer[0]?.routeName || ''
    navigator.sendBeacon(`/galog/?${queryParams}&r=${route}`)
  }
}
export default sendDDLog
